import React from 'react';
import { MeasurementLabelItem } from '@hooks/useAnalysisForPanel/useMeasurementOverlay';

export default function SvgMeasurementText({
  svgRef,
  containerRef,
  labels,
}: {
  svgRef: React.RefObject<SVGSVGElement | null>;
  containerRef: React.RefObject<HTMLDivElement>;
  labels: MeasurementLabelItem[];
}) {
  if (!containerRef.current || labels.length === 0) return null;
  const dims = containerRef.current.getBoundingClientRect();
  const fontSize = Math.max(11, Math.min(18, dims.width * 0.016));

  return (
    <svg
      ref={svgRef as React.RefObject<SVGSVGElement>}
      width={dims.width}
      height={dims.height}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 6,
      }}
    >
      {labels.map((item) => (
        <text
          key={item.measurementKey}
          x={item.x}
          y={item.y}
          fill="#ffd400"
          fontSize={fontSize}
          fontWeight={700}
          textAnchor="middle"
          alignmentBaseline="middle"
          style={{ filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.9))' }}
        >
          {item.text}
        </text>
      ))}
    </svg>
  );
}
